import _ from 'lodash'



let myFunctions = {
	version : "v4.20",
	host_url : "/secondlayerstable/"

}
export default myFunctions



// WEBPACK FOOTER //
// ./src/stores/myFunctions.js